import React, { useState, useEffect } from 'react';
import { useNavigate ,useLocation } from 'react-router-dom';
import { useLanguage } from './language/LanguageContext';
import LanguageSelector from './language/LanguageSelector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faBoxOpen, faBuilding, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FaBars, FaTimes, FaUser, FaSignOutAlt, FaHome, FaClipboardList } from 'react-icons/fa';
import Logo from './images/BB.png';

// Removed staticItemsData as we will fetch from API

function ViewItems() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  // State to hold the items data (now expecting a flat array of products)
  const [itemsData, setItemsData] = useState([]); // Initialize with empty array
  // State to track which category is currently expanded (no longer needed for grid)
  // const [expandedCategory, setExpandedCategory] = useState(null); 
  const [ vendorData , setVendorData ] = useState({});
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  // imageUrl is already defined in ViewItems.js
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  // State to hold the ID of the currently selected category for filtering
  const [activeCategoryId, setActiveCategoryId] = useState(null); // null means "All Categories"


  // Function to toggle the expanded state of a category (no longer needed)
  // const toggleCategory = (categoryId) => {
  //   setExpandedCategory(expandedCategory === categoryId ? null : categoryId);
  // };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };


  useEffect(() => {
    // Get user data from localStorage or API
    const vendorData = JSON.parse(localStorage.getItem('vendorData')) || {};
    setVendorData(vendorData || {});
    // Only fetch if vendorData.id exists
    if (vendorData.id) {
      fetchItemsbyVendor(vendorData.id);
    } else {
      console.warn("Vendor data not found in localStorage. Cannot fetch items.");
      // Optionally set an error state or display a message
    }
  }, []); // Empty dependency array means this runs once on mount


  const fetchItemsbyVendor = async (vendorId) => {
    if (!vendorId) {
      console.error("Vendor ID is required to fetch items.");
      return null; 
    }

    try {
      const response = await fetch(`${fetchUrl}vendor/get-digistore-items-by-vendorid?vendor_id=${vendorId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // Add any necessary authorization headers here, e.g.:
          // 'x-token': vendorData?.token, // Use vendorData from state if available
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error(`HTTP error! status: ${response.status}`, errorData);
        throw new Error(`Failed to fetch items: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();

      console.log("Fetched items:", data);
      // Assuming the backend response structure is { data: [...], success: true, ... }
      // And data.data is a FLAT array of product objects
      if (data.success && Array.isArray(data.data)) {
          setItemsData(data.data); // Set the flat array of items
      } else {
          console.error("Backend reported failure or unexpected data format:", data);
          setItemsData([]); // Clear items or set to empty array on failure
          throw new Error(`Backend error or invalid data: ${data.message || 'Unknown error'}`);
      }

    } catch (error) {
      console.error('Error fetching items by vendor:', error);
      // You might want to set an error state here to display an error message to the user
      // setError(error.message);
      setItemsData([]); // Clear items on error
    }
  };


  // Content translations
  const content = {
    english: {
      welcomeBack: "Welcome Back,",
      home: "Home",
      orders: "Orders",
      profile: "Profile",
      logout: "Logout"
    },
    telugu: {
      welcomeBack: "తిరిగి స్వాగతం,",
      home: "హోమ్",
      orders: "ఆర్డర్లు",
      profile: "ప్రొఫైల్",
      logout: "లాగ్అవుట్"
    }
  };
  const t = content[language];

  const handleLogout = () => {
    localStorage.removeItem('vendorData');
    localStorage.removeItem('token');
    navigate('/supplier');
  };

  // Basic loading and error states (will be more relevant with API integration)
  const loading = false; // Set to true when fetching
  const error = null; // Set to error message if fetch fails

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading items...</div>;
  }

  if (error) {
    return <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mx-4 my-4">Error: {error}</div>;
  }

 
  // --- Logic to extract unique categories (ID and Name) ---
  const uniqueCategoriesMap = new Map();
  itemsData.forEach(item => {
    const category = item.product_category_id;
    if (category && category._id && category.product_category_name) {
      uniqueCategoriesMap.set(category._id, {
        id: category._id,
        name: category.product_category_name
      });
    }
  });
  const uniqueCategories = Array.from(uniqueCategoriesMap.values());
  // -------------------------------------------------------

  // --- Logic to filter items based on active category ---
  const filteredItems = activeCategoryId
    ? itemsData.filter(item => item.product_category_id?._id === activeCategoryId)
    : itemsData;

    const handleGoBack = () => {
    navigate('/supplier/home');
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Navigation Bar */}
      <nav className="bg-white shadow-md px-2 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <img src={Logo} alt="BrickBucket Logo" className="h-10" />
          </div>

          {/* Hamburger Menu Icon */}
          <button 
            onClick={toggleMenu}
            className="text-gray-700 focus:outline-none"
          >
            {menuOpen ? (
              <FaTimes className="h-6 w-6" />
            ) : (
              <FaBars className="h-6 w-6" />
            )}
          </button>
        </div>
      </nav>

      {/* Slide-out Menu */}
      <div 
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50 ${
          menuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="p-5">
          <div className="flex justify-end">
            <button onClick={toggleMenu} className="text-gray-700">
              <FaTimes className="h-6 w-6" />
            </button>
          </div>
          
          <div className="mt-8 space-y-4">
            <div className="flex items-center p-3 rounded-md hover:bg-gray-100">
              <FaHome className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.home}</span>
            </div>
            <div className="flex items-center p-3 rounded-md hover:bg-gray-100">
              <FaClipboardList className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.orders}</span>
            </div>
            <div className="flex items-center p-3 rounded-md hover:bg-gray-100">
              <FaUser className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.profile}</span>
            </div>
            <div 
              className="flex items-center p-3 rounded-md hover:bg-gray-100 cursor-pointer"
              onClick={handleLogout}
            >
              <FaSignOutAlt className="mr-3 text-[#D64541]" />
              <span className="text-gray-700">{t.logout}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="px-4 py-6">
        <div className='flex flex-row justify-start items-center'>
        <FontAwesomeIcon onClick={handleGoBack} icon={faAngleLeft} className="text-[#D64541] text-3xl mb-4" />
        <h1 className="ml-3 text-2xl font-bold text-gray-800 mb-6">My Digistore </h1>
        </div>
          {/* Display unique category names */}
           {/* Category Filter Buttons */}
        {uniqueCategories.length > 0 && (
          <div className="mb-6 flex flex-wrap gap-2">
            {/* "All Categories" Button */}
            <button
              onClick={() => setActiveCategoryId(null)}
              className={`px-4 py-2 rounded-md text-sm font-semibold transition-colors duration-200 ${
                activeCategoryId === null
                  ? 'bg-[#D64541] text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              All Categories
            </button>
            {/* Individual Category Buttons */}
            {uniqueCategories.map(category => (
              <button
                key={category.id}
                onClick={() => setActiveCategoryId(category.id)}
                className={`px-4 py-2 rounded-md text-sm font-semibold transition-colors duration-200 ${
                  activeCategoryId === category.id
                    ? 'bg-[#D64541] text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        )}

        {/* Check if there are items to display */}
          {filteredItems.length === 0 ? (
          <div className="text-center text-gray-600 py-10">
            <FontAwesomeIcon icon={faBoxOpen} size="3x" className="mb-4" />
            <p className="text-lg font-semibold">No items selected yet.</p>
            <p className="mt-2">Go to the "Select Items" section to add products you sell.</p>
            {/* Optional: Add a button to navigate to the item selection page */}
            {/* <button className="mt-4 bg-[#D64541] text-white py-2 px-4 rounded-md hover:bg-opacity-90">Select Items</button> */}
          </div>
        ) : (
          // Display items in a 2-column grid using the ItemList.js card style
          <div className="grid grid-cols-2 gap-4">
            {filteredItems.map(item => (
              <div
                key={item._id}
                className="bg-gray-100 rounded-lg p-4 flex flex-col items-center relative" // Adopted styling from ItemList.
              >
                {/* Image Container */}
                <div className="w-24 h-24 mt-2 flex items-center justify-center relative">
                  <img
                    src={`${imageUrl}${item.product_image}`} // Use imageUrl prefix
                      alt={item.product_name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>

                {/* Item Name */}
                  <p className="text-center font-medium text-sm mb-2">
                  {item.product_name || 'Unnamed Item'}
                </p>

                {/* Removed other elements like price, UOM, checkbox from ItemList */}

              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewItems;
